import {
  AlertDialog,
  AlertDialogBody,
  AlertDialogContent,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogOverlay,
  Button,
  Text,
  Textarea
} from '@chakra-ui/react'
import { useEffect, useRef, useState } from 'react'

interface IMissingDocsDialogProps {
  isOpen: boolean
  consultantName?: string
  onClose: () => void
  onConfirm: (note: string) => Promise<void>
}

/**
 * Shown when a card is dragged into "Docs Faltantes": collects the list of
 * missing documents and warns that the consultant will be notified by e-mail.
 */
export function MissingDocsDialog({ isOpen, consultantName, onClose, onConfirm }: IMissingDocsDialogProps) {
  const cancelRef = useRef(null)
  const [note, setNote] = useState('')
  const [saving, setSaving] = useState(false)

  useEffect(() => {
    if (isOpen) setNote('')
  }, [isOpen])

  const handleConfirm = async () => {
    setSaving(true)
    try {
      await onConfirm(note.trim())
      onClose()
    } catch {
      // Kept open so the user can retry; the caller already showed the error toast.
    } finally {
      setSaving(false)
    }
  }

  return (
    <AlertDialog leastDestructiveRef={cancelRef} isOpen={isOpen} onClose={onClose} isCentered size="lg">
      <AlertDialogOverlay>
        <AlertDialogContent>
          <AlertDialogHeader fontSize="lg" fontWeight="bold">
            Mover para Docs Faltantes
          </AlertDialogHeader>

          <AlertDialogBody>
            <Text mb={3}>Descreva quais documentos estão faltando nesta solicitação:</Text>
            <Textarea
              value={note}
              onChange={(e) => setNote(e.target.value)}
              rows={5}
              placeholder="Ex.: Falta o histórico escolar original e os trabalhos do módulo 2..."
              disabled={saving}
            />
            <Text variant="caption" mt={3}>
              Ao confirmar, as observações serão registradas no histórico do card e um e-mail será enviado ao consultor{' '}
              {consultantName ? <strong>{consultantName}</strong> : ''} avisando quais documentos estão faltando, com um
              link para abrir esta solicitação no painel.
            </Text>
          </AlertDialogBody>

          <AlertDialogFooter>
            <Button ref={cancelRef} onClick={onClose} variant="outline" isDisabled={saving}>
              Cancelar
            </Button>
            <Button colorScheme="orange" onClick={handleConfirm} ml={3} isLoading={saving} isDisabled={!note.trim()}>
              Confirmar e notificar
            </Button>
          </AlertDialogFooter>
        </AlertDialogContent>
      </AlertDialogOverlay>
    </AlertDialog>
  )
}
